import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  IMappers,
  INearbyHousesExplanationRequest,
} from '../../../repositories/valuation-offer-history/v2/nearby-houses-explanation';
import {
  INearbyHousesExplanationResponse
} from "../../../repositories/valuation-offer-history/entities/nearby_houses/NearbyHousesExplanationResponse";

export const createAboutNearbyHousesMapper = (
  parameters: INearbyHousesExplanationRequest,
): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response,
  400: ({ message }) =>
    new HttpBadStatusCodeError({
      statusCode: 400,
      message: message || /* istanbul ignore next */ '',
      domain: 'aboutNearbyHousesService',
      details: { ...parameters },
    }),
});

export type TMappedResponse200 = INearbyHousesExplanationResponse;
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TMappedResponse = TMappedResponse200 | TMappedResponse400;
